import { render, staticRenderFns } from "./StockCard.vue?vue&type=template&id=5e321697&scoped=true&"
import script from "./StockCard.vue?vue&type=script&lang=js&"
export * from "./StockCard.vue?vue&type=script&lang=js&"
import style0 from "./StockCard.vue?vue&type=style&index=0&id=5e321697&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e321697",
  null
  
)

export default component.exports